import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';

class gallery {
  constructor(context) {
    context.querySelectorAll('[data-gallery]').forEach(element => {
      lightGallery(element, {
        selector: 'a:not([target="_blank"])',
        download: false,
        plugins: [lgVideo],
        subHtmlSelectorRelative: true,
      });
    });
  }
};

export default gallery;